export const acaraIconCatalog = [
  { name: 'analytics', family: '1-core-navigation' },
  { name: 'attendees', family: '1-core-navigation' },
  { name: 'coupons', family: '1-core-navigation' },
  { name: 'dashboard', family: '1-core-navigation' },
  { name: 'events', family: '1-core-navigation' },
  { name: 'help', family: '1-core-navigation' },
  { name: 'integrations', family: '1-core-navigation' },
  { name: 'messages', family: '1-core-navigation' },
  { name: 'operations', family: '1-core-navigation' },
  { name: 'orders', family: '1-core-navigation' },
  { name: 'settings', family: '1-core-navigation' },
  { name: 'team', family: '1-core-navigation' },
  { name: 'tickets', family: '1-core-navigation' },
  { name: 'vendors', family: '1-core-navigation' },
  { name: 'capacity', family: '2-ticketing-access' },
  { name: 'check-in', family: '2-ticketing-access' },
  { name: 'check-out', family: '2-ticketing-access' },
  { name: 'gate', family: '2-ticketing-access' },
  { name: 'guest-list', family: '2-ticketing-access' },
  { name: 'qr', family: '2-ticketing-access' },
  { name: 'scan-duplicate', family: '2-ticketing-access' },
  { name: 'scan-invalid', family: '2-ticketing-access' },
  { name: 'scan-success', family: '2-ticketing-access' },
  { name: 'scan', family: '2-ticketing-access' },
  { name: 'ticket-add', family: '2-ticketing-access' },
  { name: 'ticket-cancel', family: '2-ticketing-access' },
  { name: 'ticket-tier', family: '2-ticketing-access' },
  { name: 'ticket-transfer', family: '2-ticketing-access' },
  { name: 'ticket', family: '2-ticketing-access' },
  { name: 'wallet-pass', family: '2-ticketing-access' },
  { name: 'wristband', family: '2-ticketing-access' },
  { name: 'bank-transfer', family: '3-commerce-fnb' },
  { name: 'beverage', family: '3-commerce-fnb' },
  { name: 'cart', family: '3-commerce-fnb' },
  { name: 'cash', family: '3-commerce-fnb' },
  { name: 'checkout', family: '3-commerce-fnb' },
  { name: 'coupon', family: '3-commerce-fnb' },
  { name: 'food', family: '3-commerce-fnb' },
  { name: 'inventory', family: '3-commerce-fnb' },
  { name: 'invoice', family: '3-commerce-fnb' },
  { name: 'menu', family: '3-commerce-fnb' },
  { name: 'merchandise', family: '3-commerce-fnb' },
  { name: 'payment-card', family: '3-commerce-fnb' },
  { name: 'pos', family: '3-commerce-fnb' },
  { name: 'receipt', family: '3-commerce-fnb' },
  { name: 'redeem', family: '3-commerce-fnb' },
  { name: 'refund', family: '3-commerce-fnb' },
  { name: 'settlement', family: '3-commerce-fnb' },
  { name: 'sold-out', family: '3-commerce-fnb' },
  { name: 'audience', family: '4-messaging-audience' },
  { name: 'automation', family: '4-messaging-audience' },
  { name: 'broadcast', family: '4-messaging-audience' },
  { name: 'consent', family: '4-messaging-audience' },
  { name: 'contact', family: '4-messaging-audience' },
  { name: 'delivery', family: '4-messaging-audience' },
  { name: 'message', family: '4-messaging-audience' },
  { name: 'notification', family: '4-messaging-audience' },
  { name: 'read', family: '4-messaging-audience' },
  { name: 'reminder', family: '4-messaging-audience' },
  { name: 'segment', family: '4-messaging-audience' },
  { name: 'template', family: '4-messaging-audience' },
  { name: 'unsubscribe', family: '4-messaging-audience' },
  { name: 'audit-log', family: '5-operations-status' },
  { name: 'battery', family: '5-operations-status' },
  { name: 'clock', family: '5-operations-status' },
  { name: 'connection', family: '5-operations-status' },
  { name: 'critical', family: '5-operations-status' },
  { name: 'device', family: '5-operations-status' },
  { name: 'dispatch', family: '5-operations-status' },
  { name: 'incident', family: '5-operations-status' },
  { name: 'live', family: '5-operations-status' },
  { name: 'location', family: '5-operations-status' },
  { name: 'offline', family: '5-operations-status' },
  { name: 'queue', family: '5-operations-status' },
  { name: 'resolved', family: '5-operations-status' },
  { name: 'staff', family: '5-operations-status' },
  { name: 'sync-error', family: '5-operations-status' },
  { name: 'sync', family: '5-operations-status' },
  { name: 'venue-map', family: '5-operations-status' },
  { name: 'warning', family: '5-operations-status' },
  { name: 'attendance', family: '6-analytics-actions' },
  { name: 'bar-chart', family: '6-analytics-actions' },
  { name: 'calendar', family: '6-analytics-actions' },
  { name: 'compare', family: '6-analytics-actions' },
  { name: 'conversion', family: '6-analytics-actions' },
  { name: 'date-range', family: '6-analytics-actions' },
  { name: 'donut-chart', family: '6-analytics-actions' },
  { name: 'download', family: '6-analytics-actions' },
  { name: 'export', family: '6-analytics-actions' },
  { name: 'filter', family: '6-analytics-actions' },
  { name: 'funnel', family: '6-analytics-actions' },
  { name: 'line-chart', family: '6-analytics-actions' },
  { name: 'refresh', family: '6-analytics-actions' },
  { name: 'revenue', family: '6-analytics-actions' },
  { name: 'trend-down', family: '6-analytics-actions' },
  { name: 'trend-up', family: '6-analytics-actions' },
  { name: 'admin', family: '7-trust-identity' },
  { name: 'finance', family: '7-trust-identity' },
  { name: 'fraud-check', family: '7-trust-identity' },
  { name: 'key', family: '7-trust-identity' },
  { name: 'lock', family: '7-trust-identity' },
  { name: 'marketing', family: '7-trust-identity' },
  { name: 'ops', family: '7-trust-identity' },
  { name: 'owner', family: '7-trust-identity' },
  { name: 'passkey', family: '7-trust-identity' },
  { name: 'privacy', family: '7-trust-identity' },
  { name: 'role', family: '7-trust-identity' },
  { name: 'shield', family: '7-trust-identity' },
  { name: 'support', family: '7-trust-identity' },
  { name: 'unlock', family: '7-trust-identity' },
  { name: 'vendor', family: '7-trust-identity' },
  { name: 'verified', family: '7-trust-identity' },
  { name: 'view-only', family: '7-trust-identity' },
] as const

export type AcaraIconName = (typeof acaraIconCatalog)[number]['name']
export type AcaraIconFamily = (typeof acaraIconCatalog)[number]['family']

export const acaraIconFamilies = [
  { id: '1-core-navigation', label: 'Core navigation' },
  { id: '2-ticketing-access', label: 'Ticketing and access' },
  { id: '3-commerce-fnb', label: 'Commerce and F&B' },
  { id: '4-messaging-audience', label: 'Messaging and audience' },
  { id: '5-operations-status', label: 'Operations and status' },
  { id: '6-analytics-actions', label: 'Analytics and actions' },
  { id: '7-trust-identity', label: 'Trust and identity' },
] as const

